import compose from 'recompose/compose'
import withState from 'recompose/withState'
import withHandlers from 'recompose/withHandlers'

import omit from 'lodash/omit'

const enhancer = compose(
  withState('queries', 'setQueries', {}),
  withHandlers({
    setQueries: ({ setQueries }) => updater => setQueries(queries => {
      const newQuerys = updater(queries)
      return newQuerys
    }),
  }),
  withHandlers({
    updateQueries: ({ setQueries }) => (key, query) => {
      if (Object.keys(query).length) {
        setQueries(queries => ({ ...queries, [key]: query }))
      } else {
        setQueries(queries => omit(queries, [key]))
      }
    },
  })
)

module.exports = enhancer



// WEBPACK FOOTER //
// ./src/components/IncomeStatement/withQueriesState.js